import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Button } from "../../button/Button"
import { Text } from "../../Text/Text"


interface OwnProps {
  amenities: string[],
  cityRegionPostal: string;
  directionsLink: string;
  googleMapEmbedLink: string;
  streetAddress: string;
}

export type CenterInfoProps = OwnProps

export const CenterInfo: React.FC<CenterInfoProps> = ({
  amenities,
  cityRegionPostal,
  directionsLink,
  googleMapEmbedLink,
  streetAddress
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.center_info",
  });

  return (
    <div className="max-w-content-width mx-auto py-8 md:py-16 px-5 grid md:grid-cols-3 md:gap-6">
      <div>
        <Text as="h2" variant="medium-header">{t("title")}</Text>
        {googleMapEmbedLink && (
          <div className="mt-5 col-span-2 justify-center md:hidden">
            <iframe className="mx-auto w-full" src={googleMapEmbedLink} width="725" height="190" loading="lazy"></iframe>
          </div>
        )}
        <div className="mt-5 mt-8">
          <Text variant="small-subheader">{t("address")}</Text>
          {streetAddress && (<Text variant="body">{streetAddress}</Text>)}
          {cityRegionPostal && (<Text variant="body">{cityRegionPostal}</Text>)}
        </div>
        {amenities && (
          <div className="mt-5 mt-8">
            <Text variant="small-subheader">{t("amenities")}</Text>
            {amenities?.map((amenity, index) => {
              return (
                <Text key={index} variant="body">{amenity}</Text>
              )
            })}
          </div>
        )}
        <div className="mt-5 mt-8">
          <Button 
            href={directionsLink}
            text={t("button_text")}
            variant="primary-button-sky" 
          />
        </div>
      </div>
      {googleMapEmbedLink && (
        <div className="hidden col-span-2 md:block">
          <iframe className="mx-auto w-full" src={googleMapEmbedLink} width="725" height="450" loading="lazy"></iframe>
        </div>
      )}
    </div>
  )
}
